import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';

import Wrapper from '../../elements/wrapper';
import { media, TransitionMixin } from '../../helpers';

import TopBlob from '../../../images/about-top-blob.inline.svg';
import BottomBlob from '../../../images/about-bottom-blob.inline.svg';

const ContactRowsContainer = styled.div`
    position: relative;
    z-index: 100;
    padding-bottom: 5vh;
    ${media.large`padding-bottom: 10vh;`}
    .contact-row-wrapper {
        max-width: 100vw;
        ${media.large`display: flex; `}

        .column-container {
            flex: 1;
            position: relative;
            min-height: 55vh;
            ${media.medium`min-height: 65vh;`}
            ${media.large`min-height: 75vh;`}

            .svg-container {
                svg {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 110%;
                    height: 110%;
                    g {
                        mask: none;
                    }
                }
            }

            .content-container {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                z-index: 10;
                display: flex;
                align-items: center;

                .inner-wrap {
                    /* padding: 0 50px; */
                    max-width: 80%;
                    margin: 0 auto;
                    text-align: center;
                    ${media.medium`max-width: 60%;`}
                    ${media.large`max-width: 50%;`}

                    h3 {
                        color: #fff;
                        margin: 0 0 20px;
                        font-weight: 800;
                        font-family: neue-kabel, sans-serif;
                        font-size: 2.3rem;
                    }

                    p {
                        color: #fff;
                        font-size: 1.1rem;
                        margin: 0 0 30px;
                        line-height: 1.5;
                    }

                    .btn-container {
                        a {
                            border: 1px solid #f74c34;
                            background-color: #f74c34;
                            color: #fff;
                            border-radius: 5px;
                            font-weight: 800;
                            padding: 12px 30px;
                            font-size: 1rem;
                            font-family: neue-kabel, sans-serif;
                            text-decoration: none;
                            display: inline-block;
                            ${TransitionMixin('.25s')}

                            &:hover {
                                background-color: #fff;
                                color: #f74c34;
                            }
                        }
                    }
                }
            }
        }
    }
`;

const ContactRows = ({ columns }) => {
    function isOdd(num) {
        return num % 2;
    }
    return (
        <ContactRowsContainer>
            <Wrapper className="contact-row-wrapper">
                {columns &&
                    columns.map((column, index) => {
                        const {
                            contentColumnContent,
                            contentColumnTitle,
                            contentColumnColor,
                            contentColumnButton,
                        } = column || {};
                        return (
                            <div
                                className="column-container"
                                style={{
                                    backgroundColor: contentColumnColor,
                                }}
                            >
                                <div className="svg-container">
                                    {isOdd(index) === 1 ? (
                                        <TopBlob />
                                    ) : (
                                        <BottomBlob />
                                    )}
                                </div>
                                <div className="content-container">
                                    <div className="inner-wrap">
                                        <h3>{contentColumnTitle}</h3>
                                        <p>{contentColumnContent}</p>
                                        {contentColumnButton && (
                                            <div className="btn-container">
                                                <Link
                                                    to={contentColumnButton.url}
                                                >
                                                    {contentColumnButton.title}
                                                </Link>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
            </Wrapper>
        </ContactRowsContainer>
    );
};

export default ContactRows;
